export type TChartSeriesType =
  | 'kpi_act'
  | 'kpi_act_tar'
  /*| 'kpi_act_and_benchmarks_act'
  | 'kpi_act_and_subkpis_act'*/
  | 'subkpis_act';

export type TSeriesTypeChartOption = { label: string; value: TChartSeriesType };

export const seriesOptions: Array<TSeriesTypeChartOption> = [
  { label: 'KPI (ACT)', value: 'kpi_act' },
  { label: 'KPI (ACT) + KPI (TAR)', value: 'kpi_act_tar' },
  /*{ label: 'KPI (ACT) + KPI Benchmarks (ACT)', value: 'kpi_act_and_benchmarks_act' },
  { label: 'KPI (ACT) + KPI Sub-KPIs (ACT)', value: 'kpi_act_and_subkpis_act' },*/
  { label: 'KPI Sub-KPIs (ACT)', value: 'subkpis_act' }
];
export const chartColors: string[] = [
  '#00A9A3',
  '#AB1F77',
  '#C0DE27',
  '#4472C4',
  '#FFC805',
  '#52A40B',
  '#4C5155',
  '#F58F00',
  '#5DADE2',
  '#795548',
  '#EF5350',
  '#546E7A'
];

export type TChartOption = { label: string; value: string };

export type TChartComponentData = {
  elementType?: string;
  selectedPeriods?: string[];
  selectedElement?: TChartOption;
  selectedSeries?: TSeriesTypeChartOption;
  selectedChart?: string;
};
